import { Component, OnInit, Input } from '@angular/core';
import { PrinterSettings,PrinterSettingsData } from '../../../../@core/interfaces/masters/printersettings';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { imageatch_detData } from '../../../../@core/interfaces/masters/imageatch_det';
import { environment } from '../../../../../environments/environment';
import { PrintServiceService } from '../service/print-service.service';
import { DateService } from '../service/date.service';
@Component({
  selector: 'ngx-indent-common-print',
  templateUrl: './indent-common-print.component.html',
  styleUrls: ['./indent-common-print.component.scss']
})
export class IndentCommonPrintComponent implements OnInit {

  protected readonly unsubscribe$ = new Subject<void>();
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
 psDetails: PrinterSettings;
 srcname = "../.././../../assets/images/white.png";
 styleUrl = "/assets/css/print.css,/assets/css/a3landscape.css";

  constructor(protected psSrvc: PrinterSettingsData,private iatchSrvc: imageatch_detData,public PrintServiceService: PrintServiceService,public dateService: DateService) {}
    
  @Input() trackingIndentList: any[];
  @Input() trackingListPageFlag:boolean;
  @Input() currentTab:string;
  @Input() draftIndentList: any[];
  @Input() pastIndentList:any[];
  @Input() nurseindentdata:any[];
  tittle:string;

  ngOnInit(): void {
    
    
    
  }
  ngOnChanges(changes: any): void {
    if(this.trackingListPageFlag){
      this.tittle='Nurse Indent'
    }
    else{
    if(this.currentTab == 'Draft Indent'){
      this.tittle='Draft Indent'
    }
    else if( this.currentTab == 'Tracking Indent'){
      this.tittle='Tracking Indent'
    }
    else if(this.currentTab == 'Past Indent'){
      this.tittle='Past Indent'
    }
  }
  this.loadPSF()  
  
  }
  loadPSF() {
  
    this.psSrvc.list(this.tenantId + "/" + this.branchId + "/printersettings").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var ps = data.filter(ps => ps.pageSetupFor == "Report Header")

      if (ps.length > 0) {
        this.psDetails = ps[0];

        this.styleUrl = "/assets/css/print.css,/assets/css/" + (this.psDetails.paperSize).toLowerCase() + (this.psDetails.orientation).toLowerCase() + ".css";

        this.psDetails = this.PrintServiceService.onSetPsData(this.psDetails);
        this.psDetails.pageTitle= this.tittle;
      } else {
        this.psDetails = this.PrintServiceService.onGetPrinterSettings();
        this.psDetails.pageTitle= this.tittle;
      }


    }, (error) => {
    }, () => {
    });
  }
loadImg() {
  this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/logo`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

    this.srcname = "../.././../../assets/images/userav.png"
    this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`, data[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {

      this.srcname = 'data:image/jpeg;base64,' + downloaddata;
    }, (error) => {
    }, () => {
    });
  }, (error) => {
  }, () => {
  });
}

}
